import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AnimalsNotAllowedIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M12 2C9.34789 2 6.80447 3.05375 4.92917 4.92917C3.0538 6.80454 2 9.34789 2 12C2 14.6521 3.05375 17.1955 4.92917 19.0708C6.80454 20.9462 9.34789 22 12 22C14.6521 22 17.1955 20.9462 19.0708 19.0708C20.9462 17.1955 22 14.6521 22 12C21.9965 9.34877 20.9419 6.80712 19.0675 4.9327C17.1931 3.05828 14.6515 2.00353 12.0002 2.00022L12 2ZM4.20936 12C4.2085 10.0608 4.92999 8.19151 6.23404 6.75631C7.53807 5.32195 9.33068 4.42521 11.2612 4.24228C13.191 4.05932 15.1199 4.60302 16.6706 5.76724L5.76698 16.6682C4.75465 15.3228 4.20748 13.6838 4.2092 12.0001L4.20936 12ZM12 19.7906C10.3154 19.7924 8.67558 19.2461 7.32919 18.2329L18.2328 7.33189C19.3962 8.88189 19.939 10.8107 19.7561 12.7404C19.5722 14.6701 18.6764 16.4618 17.242 17.7658C15.8077 19.0698 13.9384 19.7913 11.9999 19.7905L12 19.7906Z'
                fill='currentColor'
            />
        </>
    ),
})

AnimalsNotAllowedIcon.displayName = 'AnimalsNotAllowedIcon'
